import { type CSSProperties } from 'react';

import { type ThemeOptions, type TypographyVariant } from '@mui/material';
import { type TypographyStyleOptions } from '@mui/material/styles/createTypography';
import { type Tokens } from '@zeus/themes';

/**
 * TODO: Establish this as a Style Dictionary transformer
 */
function transformLineHeight(
  lineHeight: Tokens['typography'][TypographyVariant]['lineHeight']
): TypographyStyleOptions['lineHeight'] {
  if (typeof lineHeight === 'number') {
    return lineHeight + 'px';
  }

  return lineHeight;
}

/**
 * Replace token font name with complete stack
 */
const transformFontFamily = (token: string) => {
  switch (token) {
    // Booking.com
    case 'SF Pro Text':
      return "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif";
    // Material
    default:
      return 'Roboto';
  }
};

/**
 * TODO: Establish this as a Style Dictionary transformer
 */
export function transformTypography(
  variant: Omit<Tokens['typography'][TypographyVariant], 'paragraphSpacing'>
): TypographyStyleOptions {
  return {
    fontFamily: transformFontFamily(variant.fontFamily),
    fontSize: variant.fontSize,
    fontWeight: variant.fontWeight,
    letterSpacing: variant.letterSpacing,
    lineHeight: transformLineHeight(variant.lineHeight),
    textDecoration: variant.textDecoration,
    textTransform: variant.textCase as CSSProperties['textTransform'],
    /**
     * See `createComponents()` for the transformation of the `paragraphSpacing`
     * token being applied to Typography gutterBottom/paragraph.
     */
  };
}

export function createTypography(tokens: Tokens): ThemeOptions['typography'] {
  return {
    body1: transformTypography(tokens.typography.body1),
    body2: transformTypography(tokens.typography.body2),
    button: transformTypography(tokens.typography.button),
    caption: transformTypography(tokens.typography.caption),
    fontFamily: transformFontFamily(tokens.typography.fontFamily),
    h1: transformTypography(tokens.typography.h1),
    h2: transformTypography(tokens.typography.h2),
    h3: transformTypography(tokens.typography.h3),
    h4: transformTypography(tokens.typography.h4),
    h5: transformTypography(tokens.typography.h5),
    h6: transformTypography(tokens.typography.h6),
    overline: transformTypography(tokens.typography.overline),
    subtitle1: transformTypography(tokens.typography.subtitle1),
    subtitle2: transformTypography(tokens.typography.subtitle2),
  };
}
